// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';
import { useEffect } from 'react';

import './NewCardSettingModal.css';

// React Modalで実装
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

Modal.setAppElement("#root");

const NewCardSetting1 = ({modalIsOpen, closeModal, moveNextPage, currentCard, setCurrentCard, selectedOption, setSelectedOption, previewImage, setPreviewImage, packageInfo}) => {
    const { t } = useTranslation();
    const handleUploadImage = (e) => {
        e.preventDefault();
        
        const file = e.target.files[0];
        setCurrentCard({...currentCard, option: "2"});
        setCurrentCard({...currentCard, image: file});
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreviewImage(reader.result);
        }
        reader.readAsDataURL(file);
    }
    
    const setSelectedOptionHandler = (option) => {
        setSelectedOption(option);
        setPreviewImage();
    }

    const handleChangeImageURL = (e) => {
        e.preventDefault();

        setPreviewImage(e.target.value);
        setCurrentCard({...currentCard, option: "3"});
        setCurrentCard({...currentCard, image: e.target.value});
    }

    const [update, setUpdate] = useState(false);
    
    const [cardMasterList, setCardMasterList] = useState([]);

    const handleSearchCard = (errorFlag, nextFlag) => {

        let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
        if (xsrfToken) {
            xsrfToken = xsrfToken.split('=')[1]
        }
        let token = document.cookie.split('; ').find(row => row.startsWith('token'));
        if (token) {
            token = token.split('=')[1]
        }
        console.log(packageInfo);
        fetch(`${process.env.REACT_APP_API_URL}/api/card/search?card_id_or_name=${currentCard.card_id}&type=${packageInfo.packageType}`, {
            headers: {
            'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
            'Authorization': `Bearer ${token}`,
            },
            credentials: 'include',
        })
        .then(response => response.json())
        .then(data => {
            if(!data.errors) {
                if (data.cards.length > 0) {
                    let card = data.cards[0];
                    
                    setCurrentCard({
                        card_id: card.card_id,
                        url: process.env.REACT_APP_ASSET_URL + card.image_url,
                        name: currentCard.name ? currentCard.name : card.name,
                        rank: currentCard.rank ? currentCard.rank : 1,
                        number: currentCard.number ? currentCard.number : 1,
                        rewardPoint: currentCard.rewardPoint ? currentCard.rewardPoint : 0,
                        id: currentCard.id,
                        option: "1",
                        image: process.env.REACT_APP_ASSET_URL + card.image_url,
                        psa: currentCard.psa ? currentCard.psa : 10,
                        isPsaEnabled: currentCard.isPsaEnabled ? currentCard.isPsaEnabled : 1,
                        singleTypeId: currentCard.singleTypeId,
                        singleTypeName: currentCard.singleTypeName,
                        description: currentCard.description,
                        tagId: currentCard.tagId,
                        tagName: currentCard.tagName
                    });
                    setCardMasterList(data.cards);
                    setPreviewImage(process.env.REACT_APP_ASSET_URL + card.image_url);

                    console.log(update);
                    if (nextFlag) {
                        // setUpdate(false);
                        moveNextPage();
                    }
                } else {
                    setCardMasterList([]);
                    console.log(currentCard);
                    setCurrentCard({...currentCard, card_id: ""});
                    if (!errorFlag) {
                        alert(t('new_card_setting1.error1'));
                    } else {
                        alert(t('new_card_setting1.error2'));
                    }
                }
            }
        })
        .catch(error => {
            console.log(error);
        });
    }

    const handleDeleteCard = (id) => {
        if (window.confirm(t('new_card_setting1.confirm'))) {
            let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
            if (xsrfToken) {
                xsrfToken = xsrfToken.split('=')[1]
            }
            let token = document.cookie.split('; ').find(row => row.startsWith('token'));
            if (token) {
                token = token.split('=')[1]
            }

            fetch(`${process.env.REACT_APP_API_URL}/api/card/delete/${id}`, {
                headers: {
                'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
                'Authorization': `Bearer ${token}`,
                },
                credentials: 'include',
            }).then(response => response.json())
            .then(data => {
                if(!data.errors) {
                    alert(t('new_card_setting1.deleted'));
                    // 自分をcardMasterListから削除
                    setCardMasterList(cardMasterList.filter((card) => card.card_id !== id));
                    if (cardMasterList.length > 1) {
                        let value = document.getElementById("card-search-input").value;
                        console.log(value);
                        setCurrentCard({...currentCard, card_id: value});
                        // handleSearchCard();
                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
    }

    const CreateCardImages = () => {
        return cardMasterList.map((card) => {
            return (
                <div className='new-card-setting-modal-form-preview-image-box' key={"card-master"+card.card_id}>
                    {card.shop_id &&
                        <div className="new-card-setting-modal-form-preview-image-card-delete-button" onClick={() => {handleDeleteCard(card.card_id)}}>×</div>
                    }
                    <img className={currentCard.card_id === card.card_id ? "new-card-setting-modal-form-preview-image new-card-setting-modal-form-preview-image-selected" : "new-card-setting-modal-form-preview-image"} src={process.env.REACT_APP_ASSET_URL + card.image_url} alt={card.name} id={card.card_id} onClick={handleSelectCard}/>
                    <div className="new-card-setting-modal-form-preview-image-name">
                        {card.name}
                    </div>
                </div>
            )
        })
    }

    const handleSelectCard = (e) => {
        e.preventDefault();

        let card = cardMasterList.find((card) => card.card_id === e.target.id);

        setCurrentCard({
            card_id: card.card_id,
            url: process.env.REACT_APP_ASSET_URL + card.image_url,
            name: card.name,
            rank: currentCard.rank ? currentCard.rank : "1",
            number: currentCard.number ? currentCard.number : 1,
            rewardPoint: currentCard.rewardPoint ? currentCard.rewardPoint : 100,
            id: currentCard.id,
            option: "1",
            image: process.env.REACT_APP_ASSET_URL + card.image_url,
            psa: currentCard.psa ? currentCard.psa : "10",
            isPsaEnabled: currentCard.isPsaEnabled ? currentCard.isPsaEnabled : "1",
            singleTypeId: currentCard.singleTypeId,
            singleTypeName: currentCard.singleTypeName,
            description: currentCard.description,
            tagId: currentCard.tagId,
            tagName: currentCard.tagName
        });
        setPreviewImage(process.env.REACT_APP_ASSET_URL + card.image_url);
    }

    useEffect(() => {
        if (currentCard.update && Number(selectedOption) === 1 && !update) {
            setUpdate(true);
            setCurrentCard({...currentCard, option: "1", update: false});
            handleSearchCard(true, true);
        }
    }, [currentCard.update]);
    
    useEffect(() => {
        if (currentCard.prev && Number(selectedOption) === 1) {
            setCurrentCard({...currentCard, option: "1", prev: false});
            handleSearchCard(true, false);
        }
    }, [currentCard.prev]);

    const moveNextPageHandler = () => {
        if (previewImage) {
            moveNextPage();
        } else {
            alert(t('new_card_setting1.error3'));
        }
    }

    const closeAndResetModal = () => {
        setUpdate(false);
        setPreviewImage("");
        setCardMasterList([]);
        closeModal();
    }

    return (
        <>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeAndResetModal}
            className="new-card-setting-modal"
            overlayClassName="new-card-setting-modal-overlay"
            contentLabel="Example Modal"
        >
            <div className="new-card-setting-modal-title">{t('new_card_setting1.title')}</div>
            <div className='progressbar-mini-box'>
                <ul className="progressbar-mini">
                    <li className="active"></li>
                    <li></li>
                </ul>
            </div>
            <div className="clearfix"></div>
            <div className="new-card-setting-modal-form">
                <div className="new-card-setting-modal-form-title">
                    <label>
                        <input className="new-card-setting-modal-form-radio" type="radio" checked={selectedOption === '1'} onChange={() => setSelectedOptionHandler('1')}/>
                        {t('new_card_setting1.search1')}
                    </label>
                </div>
                {selectedOption === "1" &&
                    <>
                        <input className="new-card-setting-modal-form-input" id="card-search-input" type="text" placeholder={t('new_card_setting1.name')} onChange={(e) => setCurrentCard({...currentCard, card_id: e.target.value})}/>
                        <button className="new-card-setting-modal-form-button" onClick={() => {handleSearchCard(false, false)}}>{t('new_card_setting1.search2')}</button>
                    </>
                }
                <div className="new-card-setting-modal-form-title">
                    <label>
                        <input className="new-card-setting-modal-form-radio" type="radio" checked={selectedOption === '2'} onChange={() => setSelectedOptionHandler('2')}/>
                        {t('new_card_setting1.upload')}
                    </label>
                </div>
                {selectedOption === "2" &&
                    <>
                        <input className="new-card-setting-modal-form-input-learge" type="file" accept="image/*" onChange={handleUploadImage}/>
                    </>
                }
                <div className="new-card-setting-modal-form-title">
                    <label>
                        <input className="new-card-setting-modal-form-radio" type="radio" checked={selectedOption === '3'} onChange={() => setSelectedOptionHandler('3')}/>
                        {t('new_card_setting1.url1')}
                    </label>
                </div>
                {selectedOption === "3" &&
                    <>
                        <input className="new-card-setting-modal-form-input-learge" type="text" placeholder={t('new_card_setting1.url2')} onChange={handleChangeImageURL}/>
                    </>
                }
                {selectedOption === "1" &&
                    <div className="new-card-setting-modal-form-preview">
                        <CreateCardImages />
                    </div>
                }
                {selectedOption !== "1" &&
                    <div className="new-card-setting-modal-form-preview">
                        {previewImage && <img className="new-card-setting-modal-form-preview-image" src={previewImage} alt={t('new_card_setting1.preview')}/>}
                    </div>
                }
            </div>
            <div className="new-card-setting-modal-button">
            <button className="new-card-setting-modal-button-cancel" onClick={closeAndResetModal}>{t('new_card_setting1.back')}</button>
            <button className="new-card-setting-modal-button-add" onClick={moveNextPageHandler}>{t('new_card_setting1.next')}</button>
            </div>
        </Modal>
        </>
    );
}

export default NewCardSetting1;